import NameFromNetwork from "./name_from_network";
import Class from "../jquery_class";

export default Class.extend({
  init: function(
    advertiserNameFromNetwork,
    affiliateNameFromNetwork,
    advertiserIdFriendlyName,
    affiliateIdFriendlyName,
    advertiserCampaignIdName,
    advertiserCampaignIdFriendlyName
  ) {
    this.advertiserNameFromNetwork = new NameFromNetwork(advertiserNameFromNetwork);
    this.affiliateNameFromNetwork = new NameFromNetwork(affiliateNameFromNetwork);
    this.advertiserIdFriendlyName = advertiserIdFriendlyName;
    this.affiliateIdFriendlyName = affiliateIdFriendlyName;
    this.advertiserCampaignIdName = advertiserCampaignIdName;
    this.advertiserCampaignIdFriendlyName = advertiserCampaignIdFriendlyName;
  }
});
